import { Controller } from "@hotwired/stimulus";
import { Modal } from "flowbite";

export default class extends Controller {
    connect() {
        const modalToggles = this.element.querySelectorAll("[data-modal-toggle]");
        modalToggles.forEach((toggle) => {
            const modalId = toggle.getAttribute("data-modal-target");
            const modalEl = document.getElementById(modalId);

            if (!modalEl) return;

            // Cria uma instância do modal
            const modal = new Modal(modalEl);

            // Abre modal ao clicar no botão
            toggle.addEventListener("click", () => modal.toggle());

            // Fecha modal com qualquer botão que tenha data-modal-hide
            modalEl.querySelectorAll("[data-modal-hide]").forEach((btn) => {
                btn.addEventListener("click", () => modal.hide());
            });
        });
    }
}
